import { render } from "./DashboardCrearOrdenEntrega.vue?vue&type=template&id=2a9bbf12&scoped=true"
import script from "./DashboardCrearOrdenEntrega.vue?vue&type=script&lang=js"
export * from "./DashboardCrearOrdenEntrega.vue?vue&type=script&lang=js"

import "./DashboardCrearOrdenEntrega.vue?vue&type=style&index=0&id=2a9bbf12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a9bbf12"]])

export default __exports__